import { getSearchArea } from '@bridebook/toolbox/src/getSearchUrl';
import { isCountryCode, isStringNonEmpty } from '@bridebook/toolbox/src/is';
import gazetteer, { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { extractLocationName } from '@bridebook/web/app-shared/lib/search/utils/utils';
import { IWedding } from '@bridebook/models/source/models/Weddings.types';

type LocationSearchData = {
  weddingLocation: string;
  area: string;
  countryCode: CountryCodes | undefined;
  isPrediction: boolean;
  placeId: string;
};

export const buildLocationSearchData = ({
  location,
  weddingCountry,
}: {
  location: IWedding['location'] | null;
  weddingCountry: CountryCodes | undefined;
}): LocationSearchData => {
  const weddingLocation = extractLocationName(location);

  const countryCode = isCountryCode(location?.country) ? location?.country : weddingCountry;

  const shouldUseSearchArea = !!location && countryCode !== CountryCodes.GB;

  let area = weddingLocation;

  if (shouldUseSearchArea) {
    const locationMarket = countryCode ? gazetteer.getMarketByCountry(countryCode) : undefined;

    const adminArea =
      location?.adminArea && locationMarket
        ? locationMarket.sortAdminAreas(location.adminArea, 1)[0]
        : undefined;

    const areaContext = [adminArea, location?.country].filter(isStringNonEmpty);

    area = getSearchArea({ area: location.name, areaContext });
  }

  const isPrediction = location?.provider?.type === 'google.places';

  return {
    weddingLocation,
    area,
    countryCode,
    isPrediction,
    placeId: location?.provider?.id ?? '',
  };
};
